import React from 'react'
import styled from 'styled-components'
import BlueFlag from '../../assets/icons/blue-flag.png'
import { string } from 'prop-types'

const ComboMessage = styled.div`
  background: #e5e9fe;
  border-radius: 8px;
  width: 100%;
  max-width: ${( { maxWidth } ) => maxWidth};
  @media (max-width: 520px) {
    width: calc(100vw - 50px);
  }

  padding: 8px;
  color: #3f49b5;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  font-family: "Noto Sans Display", sans-serif;

  .icon-div {
    padding: 0px 10px 0px 5px;
    display: flex;
    align-items: center;
  }
`

export function MessageCombo( { text, maxWidth } ) {
  return (
    <ComboMessage maxWidth={ maxWidth }>
      <div className="flex-row">
        <div className="icon-div">
          <img
            alt="Logo em azul"
            src={ BlueFlag }
          />
        </div>

        <span>{text}</span>
      </div>
    </ComboMessage>
  )
}

MessageCombo.propTypes = {
  'maxWidth': string.isRequired,
  'text': string.isRequired
}
